import { Translate } from '@dreryk/react-common';
import { StrongText } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../../translations';

export const ExistingAssociationPanelAssociationDate = (): JSX.Element => {
   return (
      <StrongText testId={'associationDate'}>
         <Translate>{mfaSettingsTranslationKeys.associationDate}</Translate>
      </StrongText>
   );
};
